import { render, staticRenderFns } from "./AcuerdoImpresionTab.vue?vue&type=template&id=ebf115e6&"
import script from "./AcuerdoImpresionTab.vue?vue&type=script&lang=js&"
export * from "./AcuerdoImpresionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports